export const getCurrentDate = () => {
  return new Date().toLocaleDateString("de-DE", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
};

export const getNextMonthsDate = () => {
  let currentDate = new Date();
  return new Date(
    currentDate.setDate(currentDate.getDate() + 30)
  ).toLocaleDateString("de-DE", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
};

export const formatDate = (date: string) => {
  return new Date(date).toLocaleDateString("de-DE", {
    year: "numeric",
    month: "numeric",
    day: "numeric",
  });
};
